'use client';
import React from 'react';
import { useEffect, useId } from "react"
import { useFormContext, useController, useFormState } from 'react-hook-form'

function useMioForm(name, required = false) {
    const mioID = useId();

    const { control, setValue } = useFormContext();
    // const { errors, dirtyFields, isValid, touchedFields } = useFormState({ control, name: [name] });
    // const { field } = useController({ name, control, rules: { required } });

    const {
        field,
        fieldState: { isTouched, isDirty, invalid: isInvalid },
    } = useController({
        name,
        control,
        rules: { required }
    });
    // const isInvalid = false;


    // const error = {};
    // const isTouched = false;
    // const isDirty = false;

    // const isInvalid = invalid;

    // const isDirty = !!dirtyFields[name];
    // const isTouched = !!touchedFields[name];

    return { control, field, isInvalid, mioID, setValue, isDirty, isTouched };
}
export default useMioForm